import React from 'react';
import { Alert, Button, Space } from 'antd';
import { useTranslate } from '@/translations';
import { useCall } from './CallContext';
import './GlobalCallBar.scss';

export const GlobalCallBar = () => {
  const { t } = useTranslate();
  const {
    status,
    error,
    result,
    resultDirection,
    acceptCall,
    declineCall,
    hangUp,
    returnToConversation,
    dismissResult,
  } = useCall();

  if (status === 'idle' && !result) return null;

  const message = result
    ? result === 'missed'
      ? resultDirection === 'outgoing'
        ? 'No answer'
        : 'Missed call'
      : result === 'declined'
        ? 'Call declined'
        : result === 'busy'
          ? 'Operator busy'
          : result === 'cancelled'
            ? 'Call cancelled'
            : result === 'completed'
              ? 'Call ended'
              : t('commsCallFailed')
    : status === 'ringing'
      ? t('commsCallIncoming')
      : status === 'connecting'
        ? t('commsCallConnecting')
        : status === 'active'
          ? t('commsCallActive')
          : status === 'reconnecting'
            ? 'Reconnecting'
            : status === 'ending'
              ? t('commsCallEnding')
              : (error ?? t('commsCallFailed'));

  const actions = result ? (
    <Button onClick={dismissResult}>Close</Button>
  ) : status === 'ringing' ? (
    <Space>
      <Button type="primary" onClick={() => void acceptCall()}>
        {t('commsCallAccept')}
      </Button>
      <Button danger onClick={() => void declineCall()}>
        {t('commsCallDecline')}
      </Button>
    </Space>
  ) : (
    <Space>
      <Button onClick={returnToConversation}>{t('commsCallReturn')}</Button>
      <Button
        danger
        disabled={status === 'ending'}
        onClick={() => void hangUp()}
      >
        {t('commsCallHangUp')}
      </Button>
    </Space>
  );

  return (
    <div className="comms-global-call-bar" role="status">
      <Alert
        type={status === 'failed' ? 'error' : 'info'}
        showIcon
        message={message}
        action={actions}
      />
    </div>
  );
};
